import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-programs", (props) => {
  return <ContentBlocks blocks={props.program?.contentBlocks || []} />
})
